import "./styles.scss";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Dropdown, FormField } from "@/component-library";
import {
  updateAppointmentEndTime,
  updateAppointmentStartTime,
  updateAppointmentTime,
} from "@/redux/actions/calendar";

import { transformValueToDropDown } from "../../utils/appointmentPickerUtils";

// filters drop down options based on the label and not the value
// we do this because the value is represented in 24hr time
const filterByLabel = (option, inputValue) => {
  return option.label.toLowerCase().includes(inputValue.toLowerCase());
};

export const TimePicker = ({ menuPosition }) => {
  const dispatch = useDispatch();
  const appointmentSelections = useSelector((state) => state.calendar.appointmentSelections);
  const errors = useSelector((state) => state.calendar.appointmentSelectionErrors);
  const options = appointmentSelections?.selectableTimes ?? [];

  return (
    <FormField
      className="apti-CalendarAppointmentDateTimePicker--field apti-CalendarAppointmentDateTimePicker--wrapped-fields"
      errorMessage={errors.time}
      label="Time"
    >
      <Dropdown
        error={errors.time !== null}
        filterOptions={filterByLabel}
        menuPosition={menuPosition}
        name="time"
        onChange={(value) => {
          dispatch(updateAppointmentTime(value.target.value));
        }}
        options={options}
        placeholder="Time"
        value={transformValueToDropDown(options, appointmentSelections.time)}
      />
    </FormField>
  );
};

export const FromToTimePicker = ({ menuPosition }) => {
  const dispatch = useDispatch();
  const appointmentSelections = useSelector((state) => state.calendar.appointmentSelections);
  const errors = useSelector((state) => state.calendar.appointmentSelectionErrors);
  const fromOptions = appointmentSelections?.selectableTimesFrom;
  const toOptions = appointmentSelections?.selectableTimesTo;

  return (
    <div className="apti-CalendarAppointmentDateTimePicker--wrapper-container">
      <FormField
        className="apti-CalendarAppointmentDateTimePicker--wrapped-fields"
        errorMessage={errors.startTime}
        label="From"
      >
        <Dropdown
          error={errors.startTime !== null}
          filterOptions={filterByLabel}
          menuPosition={menuPosition}
          name="from"
          onChange={(value) => {
            dispatch(updateAppointmentStartTime(value.target.value));
          }}
          options={fromOptions}
          placeholder="From"
          value={transformValueToDropDown(fromOptions, appointmentSelections.startTime)}
        />
      </FormField>
      <FormField
        className="apti-CalendarAppointmentDateTimePicker--wrapped-fields"
        errorMessage={errors.endTime}
        label="To"
      >
        <Dropdown
          error={errors.endTime !== null}
          filterOptions={filterByLabel}
          menuPosition={menuPosition}
          name="to"
          onChange={(value) => {
            dispatch(updateAppointmentEndTime(value.target.value));
          }}
          options={toOptions}
          placeholder="To"
          value={transformValueToDropDown(toOptions, appointmentSelections.endTime)}
        />
      </FormField>
    </div>
  );
};
